import { render, staticRenderFns } from "./config-editor.vue?vue&type=template&id=06b8ab7a&"
import script from "./config-editor.vue?vue&type=script&lang=ts&"
export * from "./config-editor.vue?vue&type=script&lang=ts&"
import style0 from "./config-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports